import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const ModerateCultureSite = {
  id: '20',
  name: 'Moderate Culture Site',
  width: 2,
  height: 2,
  type: BuildingType.CULTURE,
  era: 'stoneAge',
  icon: 'Culture_Range',
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Culture_Sites/Moderate_Culture_Site',
  flags: 0,
  counts: {
    stoneAge: 2,
    bronzeAge: 2,
    minoanEra: 3,
    classicGreece: 3,
    earlyRome: 3,
    romanEmpire: 4,
    byzantineEra: 4,
    ageOfTheFranks: 4,
    feudalAge: 4,
    iberianEra: 4,
    kingdomOfSicily: 5,
    highMiddleAges: 5,
    earlyGothicEra: 6,
    lateGothicEra: 6,
  },
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([160, 200, 240, 280, 320, 400, 480, 560, 680, 800, 960, 1160, 1300, 1440]),
      CultureRange.asFlat(2),
    ),
  ]),
};

export default ModerateCultureSite;
